import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserApp from "./Users";
import StorageApp from "./Storages";
import ItemApp from "./Items";
import LogApp from "./Logs";
import Login from "./Login";
import Logout from "./Logout";
import Status from "./Status";
import MyPage from "./MyPage";
import FetchScan from "./FetchScan";
import FetchQRList from "./FetchQRList";
import FetchOffout from "./FetchOffout";
import Header from "./Header";
import AuthProvider from "./AuthProvider";
import { TitleForPC } from './Title';
import BootstrapSample from './BootstrapSample';
import Offtop from './Offtop';
import Offscan from './Offscan';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './App.css';

function App() {
  return (
  <AuthProvider>
    <Router>
      <Container fluid>
        <Row>
          <Header />
          <Col xs={12} md={9} className="right-column">
            <TitleForPC />
            <UserApp />
            <StorageApp />
            <ItemApp />
            <LogApp />
            <Routes>
              <Route path="/"         element={<MyPage />} />
              <Route path="qr/"       element={<FetchQRList />} />
              <Route path="scan/:id"  element={<FetchScan />} />
              <Route path="status/"   element={<Status />} />
              <Route path="bs/"       element={<BootstrapSample />} />
              <Route path="login/"    element={<Login />} />
              <Route path="logout/"   element={<Logout />} />
              <Route path="offtop/"   element={<Offtop />} />
              <Route path="offscan/"  element={<Offscan />} />
              <Route path="offout/"   element={<FetchOffout />} />
            </Routes>
          </Col>
        </Row>
      </Container>
    </Router>
  </AuthProvider>
  );
}

export default App;
